<div class="app-layout">

  <div class="header-wrapper">
    <np-header
      [sitename]="'substantiation assessment tool'"
      [hasEnterpriseSearch]="false">
    </np-header>
    <div class="user-info">
      <span class="user-name">{{ userName }}</span>
      <img [src]="userProfileImage" alt="" class="user-profile-image" />
    </div>
  </div>

  <!-- NextPage Navigation Component -->
  <np-nav [navItems]="navigationItems"></np-nav>

  <!-- Sub-bar: breadcrumb + last synced -->
  <div class="app-sub-bar">
    <div class="app-sub-bar-inner">
      <span class="breadcrumb-text">{{ breadcrumb }}</span>
    </div>
  </div>

  <!-- Main Content Area -->
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>

  <!-- NextPage Footer Component -->
  <np-footer
    [copyright]="'2026 All rights reserved.'"
    [opCoName]="'CVX Development'">
  </np-footer>

</div>
